/* ============================================================
   ELEMENTA · Fix de estilos para la pagina de Rivo Loyalty
   ------------------------------------------------------------
   POR QUE ESTE ARCHIVO ES JS Y NO CSS:

   El tema sirve `assets/styles.css` (estatico) que en esta tienda
   NO se puede borrar ni editar desde Shopify. Dentro trae, quemado:

       button { background-color:#000; color:#000 }        (linea 2010)
       .rivo-card:hover .rivo-card-icon svg path {
           fill:#ffffff !important }                        (linea 12929)

   Esa ultima regla pinta el icono de BLANCO sobre una tarjeta BLANCA
   -> el icono desaparece. Al tener `!important` y venir de un archivo
   intocable, no se le puede ganar de forma fiable solo con CSS.

   Este script inyecta las correcciones con la maxima prioridad posible
   y SOLO en la pagina de loyalty. No toca ninguna otra pagina.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Guarda: solo en la pagina de Rivo ---- */
  var SUFFIX = 'template-suffix-rivo-loyalty-landing-page';
  if (!document.body || document.body.className.indexOf(SUFFIX) === -1) return;

  /* ---- Colores: se leen del tema, no se hardcodean ---- */
  var CFG = window.ELEMENTA_RIVO_CFG || {};
  var TEXTO   = CFG.texto   || '#423f3f';
  var BOTON   = CFG.boton   || '#000000';
  var BOTONTX = CFG.botonTx || '#ffffff';

  /* Tipografias del tema (se pasan desde theme.liquid con los filtros de
     Shopify, asi que siguen lo que este puesto en el Theme Editor).
     Rivo deja `title_font_family` y `subtitle_font_family` VACIOS, con lo
     que genera `--rivo-title-font-family:` sin valor -> CSS invalido ->
     el navegador cae en su fuente por defecto y la pagina se ve distinta
     al resto del sitio. */
  /* Respaldo: si la config no llega (Liquid mal resuelto, cache, etc.)
     se leen las fuentes DEL PROPIO TEMA midiendo elementos reales.
     Asi nunca se cae en 'inherit', que heredaria del body y dejaria
     los titulos con la fuente del cuerpo. */
  function fuenteDe(tag, contenedor) {
    try {
      var el = document.createElement(tag);
      el.style.cssText = 'position:absolute!important;visibility:hidden!important;height:0!important;';
      (contenedor || document.body).appendChild(el);
      var f = getComputedStyle(el).fontFamily;
      el.remove();
      return f || '';
    } catch (e) { return ''; }
  }

  var FUENTE_TEXTO  = CFG.fuenteTexto  || fuenteDe('p')  || 'inherit';
  var FUENTE_TITULO = CFG.fuenteTitulo || fuenteDe('h2') || 'inherit';

  /* ------------------------------------------------------------
     1) CSS inyectado al FINAL del <head>, con selectores de alta
        especificidad. Al ir despues de styles.css y usar html+body
        como raiz, gana sin depender del orden de los assets.
     ------------------------------------------------------------ */
  var S = 'html body.' + SUFFIX;

  var css = [
    /* Variables que la app espera (fue escrita para el tema Dawn) */
    ':root{',
    '  --color-button:' + hexToRgb(BOTON) + ';',
    '  --color-button-text:' + hexToRgb(BOTONTX) + ';',
    '  --alpha-button-background:1;',
    '}',

    /* --- ICONO DE LA TARJETA: el bug principal --- */
    S + ' .rivo-card .rivo-card-icon svg path,',
    S + ' .rivo-card:hover .rivo-card-icon svg path,',
    S + ' .rivo-card .rivo-card-icon svg,',
    S + ' .rivo-card:hover .rivo-card-icon svg{',
    '  fill:var(--rivo-card-font-color,' + TEXTO + ')!important;',
    '}',

    /* --- TARJETA: que el texto no herede blanco --- */
    S + ' .rivo-card,',
    S + ' .rivo-card:hover,',
    S + ' .rivo-card:focus{',
    '  color:var(--rivo-card-font-color,' + TEXTO + ')!important;',
    '  border-color:transparent!important;',
    '}',

    /* --- BOTONES REALES (hero y modal): normal --- */
    S + ' .rivo-button:not(.rivo-success-button):not(.rivo-loading-spinner),',
    S + ' .rivo-modal__btn:not(.rivo-success-button):not(.rivo-loading-spinner),',
    S + ' .rivo-modal-button:not(.rivo-success-button):not(.rivo-loading-spinner){',
    '  background-color:' + BOTON + '!important;',
    '  color:' + BOTONTX + '!important;',
    '  border:1px solid ' + BOTON + '!important;',
    '}',

    /* --- BOTONES REALES: hover invertido --- */
    S + ' .rivo-button:not(.rivo-success-button):not(.rivo-loading-spinner):hover,',
    S + ' .rivo-modal__btn:not(.rivo-success-button):not(.rivo-loading-spinner):hover,',
    S + ' .rivo-modal-button:not(.rivo-success-button):not(.rivo-loading-spinner):hover{',
    '  background-color:' + BOTONTX + '!important;',
    '  color:' + BOTON + '!important;',
    '  border-color:' + BOTON + '!important;',
    '}',

    /* --- ESTADO "COPIADO": la app dibuja una palomita con
           :before{background-color:currentColor} y pone el texto
           transparente. Necesita fondo transparente. --- */
    S + ' .rivo-success-button,',
    S + ' .rivo-success-button:hover,',
    S + ' .rivo-loading-spinner,',
    S + ' .rivo-loading-spinner:hover{',
    '  background-color:transparent!important;',
    '  background:transparent!important;',
    '  border-color:transparent!important;',
    '}',
    S + ' .rivo-success-button:before{',
    '  background-color:' + TEXTO + '!important;',
    '}',

    /* --- BOTONES TRANSPARENTES de la app (cerrar, copiar, cargar mas) --- */
    S + ' .rivo-modal__close,',
    S + ' .rivo-modal__close:hover,',
    S + ' .rivo-copy-button,',
    S + ' .rivo-copy-button:hover,',
    S + ' .rivo-points-table-load-more-button,',
    S + ' .rivo-points-table-load-more-button:hover{',
    '  background-color:transparent!important;',
    '  background:transparent!important;',
    '  border:0!important;',
    '}',
    S + ' .rivo-modal__close{color:var(--rivo-modal-text-color,' + TEXTO + ')!important;}',
    S + ' .rivo-copy-button{color:' + TEXTO + '!important;}',
    S + ' .rivo-copy-button svg{fill:currentColor!important;}',
    S + ' .rivo-points-table-load-more-button{color:' + TEXTO + '!important;text-decoration:underline;}',

    /* --- CONTENEDORES: nunca llevan fondo --- */
    S + ' .rivo-modal-cta,',
    S + ' .rivo-hero-buttons{background:transparent!important;border:0!important;}',

    /* ============================================================
       INTERLINEADO DE TITULOS

       El tema define `body { line-height: 1.5em }` — en EM, no sin unidad.
       `1.5em` se resuelve UNA vez contra el font-size del body (14px) = 21px
       fijo, y ese valor se HEREDA tal cual. Un titulo de 32px acaba con
       lineas de 21px -> se encinan cuando el texto ocupa dos renglones
       ("Hola Luis, tienes 664 Puntos").

       Se corrige con un valor SIN unidad, que cada elemento recalcula
       segun su propio tamano.
       ============================================================ */
    S + ' .rivo-hero-title,',
    S + ' .rivo-lp-section-title,',
    S + ' .rivo-card-title,',
    S + ' .rivo-modal__title,',
    S + ' .rivo-account-block-title,',
    S + ' .rivo-account-card-title,',
    S + ' .rivo-th-tier-name,',
    S + ' .rivo-lp-section h1,',
    S + ' .rivo-lp-section h2,',
    S + ' .rivo-lp-section h3,',
    S + ' .rivo-lp-section h4{',
    '  line-height:1.25!important;',
    '  text-wrap:balance;',        /* reparte las lineas de forma pareja */
    '}',

    /* Subtitulos y textos: algo mas de aire, siguen siendo legibles */
    S + ' .rivo-lp-section-subtitle,',
    S + ' .rivo-hero-description,',
    S + ' .rivo-card-description,',
    S + ' .rivo-modal__description,',
    S + ' .rivo-modal-p{',
    '  line-height:1.5!important;',
    '  text-wrap:pretty;',         /* evita palabras huerfanas al final */
    '}',

    /* Tabla de actividad: las celdas tambien heredaban el 21px fijo */
    S + ' .rivo-lp-section table td,',
    S + ' .rivo-lp-section table th{',
    '  line-height:1.45!important;',
    '}',

    /* ============================================================
       TIPOGRAFIA: que Rivo use las mismas fuentes que el tema.
       Rivo deja `title_font_family` / `subtitle_font_family` VACIOS,
       asi que genera `--rivo-title-font-family:` sin valor -> CSS
       invalido -> el navegador cae en su fuente por defecto y la
       pagina se ve distinta al resto del sitio.
       ============================================================ */
    S + '{',
    '  --rivo-title-font-family:' + FUENTE_TITULO + ';',
    '  --rivo-subtitle-font-family:' + FUENTE_TEXTO + ';',
    '  --rivo-card-title-font-family:' + FUENTE_TITULO + ';',
    '  --rivo-card-subtitle-font-family:' + FUENTE_TEXTO + ';',
    '}',

    /* Titulos -> fuente de titulos del tema */
    S + ' .rivo-hero-title,',
    S + ' .rivo-lp-section-title,',
    S + ' .rivo-card-title,',
    S + ' .rivo-modal__title,',
    S + ' .rivo-account-block-title,',
    S + ' .rivo-account-card-title,',
    S + ' .rivo-th-tier-name,',
    S + ' .rivo-lp-section h1,',
    S + ' .rivo-lp-section h2,',
    S + ' .rivo-lp-section h3,',
    S + ' .rivo-lp-section h4{',
    '  font-family:' + FUENTE_TITULO + '!important;',
    '}',

    /* Textos, subtitulos y botones -> fuente base del tema */
    S + ' .rivo-hero-description,',
    S + ' .rivo-lp-section-subtitle,',
    S + ' .rivo-card-description,',
    S + ' .rivo-account-block-subtitle,',
    S + ' .rivo-modal-p,',
    S + ' .rivo-button,',
    S + ' .rivo-modal__btn,',
    S + ' .rivo-modal-button,',
    S + ' .rivo-points-table-load-more-button,',
    S + ' .rivo-lp-section p,',
    S + ' .rivo-lp-section td,',
    S + ' .rivo-lp-section th,',
    S + ' .rivo-lp-section span,',
    S + ' .rivo-lp-section li{',
    '  font-family:' + FUENTE_TEXTO + '!important;',
    '}'
  ].join('\n');

  function hexToRgb(h) {
    h = String(h).replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var n = parseInt(h, 16);
    return ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255);
  }

  function inyectar() {
    var prev = document.getElementById('elementa-rivo-fix-style');
    if (prev) prev.remove();
    var st = document.createElement('style');
    st.id = 'elementa-rivo-fix-style';
    st.textContent = css;
    document.head.appendChild(st);   /* al final del head = ultima palabra */
  }

  inyectar();

  /* ------------------------------------------------------------
     2) Red de seguridad: la app pinta su contenido con JS despues
        de cargar. Si vuelve a inyectar estilos propios, se re-aplica
        el nuestro al final del head para conservar la prioridad.
     ------------------------------------------------------------ */
  var reintentos = 0;
  var obs = new MutationObserver(function () {
    if (document.getElementById('elementa-rivo-fix-style') !== document.head.lastElementChild) {
      if (reintentos++ < 50) inyectar();
    }
  });
  try {
    obs.observe(document.head, { childList: true });
  } catch (e) {}

  /* Deja de vigilar despues de 15s: la pagina ya termino de montarse. */
  setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 15000);
})();
